import React from 'react'
import styled from '@emotion/styled'

import { fontSize3XSmall, grayLight20, fontFamilyOpenSans } from '../../../constants/principles'
import { FlexRowDiv } from '../Basics'
import { useStateValue } from '../../../hooks'
import { removeInvalidCharacters } from '../../../utils/siteUtils'

export default ({ question, questionId, saveQuestionResponse, getQuestionResponse }) => {
  const [localValue, setLocalValue] = useStateValue(getQuestionResponse(questionId) || '')

  return (
    <FlexLeftDiv>
      <StyleLabel htmlFor={questionId}>{question.value || question.label}</StyleLabel>
      <StyledSpan>max 300 characters</StyledSpan>
      <StyledTextArea
        data-testid={`tb-${questionId
          ?.toString()
          .replace(/[^A-Z0-9]/gi, '-')
          .toLowerCase()}-comment`}
        name={questionId}
        value={localValue}
        placeholder={'Comments'}
        rows={3}
        cols={40}
        maxLength={300}
        onChange={e => setLocalValue(removeInvalidCharacters(e.target.value))}
        onBlur={() => saveQuestionResponse(questionId, removeInvalidCharacters(localValue))}
      />
    </FlexLeftDiv>
  )
}

const StyledTextArea = styled.textarea`
  font-family: ${fontFamilyOpenSans};
  width: 100%;
  margin-bottom: 24px;
`

const StyledSpan = styled.span`
  font-size: ${fontSize3XSmall};
  color: ${grayLight20};
  text-align: right;
  margin-top: 8px;
  padding-left: 40px;
  flex-grow: 1;
`

const FlexLeftDiv = styled(FlexRowDiv)`
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 90%;
`
const StyleLabel = styled.label`
  font-size: ${fontSize3XSmall};
  color: ${grayLight20};
  text-align: left;
  margin-top: 8px;
`
